module.exports = __webpack_public_path__ + "static/media/save.b16a0a23.svg";